import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventDefault]',
  standalone: true,
})
export class PreventDefaultDirective {
  @HostListener('click', ['$event'])
  public onClick(e: Event): void {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}
